"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnonymousStudentProfileSynced = void 0;
const event_type_1 = require("../enumerations/event-type");
class AnonymousStudentProfileSynced {
    constructor(timestamp, state) {
        this.timestamp = timestamp;
        this.state = state;
        this.eventType = AnonymousStudentProfileSynced.EventType;
    }
}
exports.AnonymousStudentProfileSynced = AnonymousStudentProfileSynced;
AnonymousStudentProfileSynced.EventType = event_type_1.EventType.AnonymousStudentProfileSynced;
